import { createSelector } from "@reduxjs/toolkit";

import { MissionState } from "@skydio/pbtypes/pbtypes/vehicle/skills/mission_pb";

import type { ValueType } from "@skydio/core";
import type { AppState } from "../store";

export const getMissionState = (state: AppState) => state.mission;
export const getWaypointTrajectory = (state: AppState) => state.mission.waypointTrajectory;
export const getIsRunningMission = createSelector(getMissionState, state =>
  (
    [
      MissionState.MissionStateEnum.VEHICLE_PREP,
      MissionState.MissionStateEnum.IN_PROGRESS,
    ] as ValueType<MissionState.MissionStateEnumMap>[]
  ).includes(state.stateEnum)
);
export const getIsFreeLookActive = createSelector(getMissionState, state => state.freeLookActive);
export const getIsFreeLookInitialized = createSelector(
  getMissionState,
  state => state.freeLookInitialized
);
export const getSupportedFreeLookMode = createSelector(
  getMissionState,
  state => state.supportedFreeLookMode
);
